import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {DrawSchema} from '../_interface/schema.model';
import * as SchemaActions from '../_actions/schema.actions';
import {JournalEditMode} from '../../../_interface/journal-edit-mode.enum';

export const schemasFeatureKey = 'schemas';

export interface SchemaEntityState extends EntityState<DrawSchema> {
	edit: Partial<DrawSchema> | null;
	loaded: boolean;
	mode: JournalEditMode;
}

export const adapter: EntityAdapter<DrawSchema> = createEntityAdapter<DrawSchema>(
	{selectId: model => model.schemaId}
);

export const initialState: SchemaEntityState = adapter.getInitialState({
	edit: null,
	loaded: false,
	mode: null
});


export const reducer = createReducer(
	initialState,
	on(SchemaActions.setSchemaForEdit,
		(state, {schema}) => ({
			...state,
			edit: {
				...schema
			}
		})
	),
	on(SchemaActions.cancelSchemaForEdit,
		(state) => ({
			...state,
			edit: null,
			mode: null
		})
	),
	on(SchemaActions.addSchema,
		(state, action) => adapter.addOne(action.schema, state)
	),
	on(SchemaActions.upsertSchema,
		(state, action) => adapter.upsertOne(action.schema, {...state, edit: null, mode: null})
	),
	on(SchemaActions.addSchemas,
		(state, action) => adapter.addMany(action.schemas, state)
	),
	on(SchemaActions.upsertSchemas,
		(state, action) => adapter.upsertMany(action.schemas, state)
	),
	on(SchemaActions.updateSchema,
		(state, action) => adapter.updateOne(action.schema, state)
	),
	on(SchemaActions.updateSchemas,
		(state, action) => adapter.updateMany(action.schemas, state)
	),
	on(SchemaActions.deleteSchemaSuccess,
		(state, action) => adapter.removeOne(action.id, {...state, edit: null, mode: null})
	),
	on(SchemaActions.deleteSchemas,
		(state, action) => adapter.removeMany(action.ids, state)
	),
	on(SchemaActions.loadSchemas,
		(state, action) => adapter.setAll(action.schemas, {...state, loaded: true})
	),
	on(SchemaActions.clearSchemas,
		state => adapter.removeAll(state)
	),
	on(SchemaActions.changeSchemaMode, (state, {mode}) => ({
		...state,
		mode
	}))
);


export const {
	selectIds,
	selectEntities,
	selectAll,
	selectTotal,
} = adapter.getSelectors();
